"use client"

import { useEffect, useState } from "react"
import { ChatLauncherLazy } from "./chat-launcher-lazy"
import type { ChatLauncherProps } from "./chat-launcher"
import { hasEllaNlPreviewActive } from "@/lib/ella-nl-preview"

/**
 * Mounts the Ella chat launcher in the Dutch market ONLY for a visitor who
 * armed the `?ella-nl=<ELLA_NL_PREVIEW_TOKEN>` magic link (the
 * `ella-nl-preview-active` cookie). Lets staff dogfood NL chat — in both Dutch
 * and English — on prod before `feature:chat` is widened to include `nl`.
 *
 * The cookie is read post-hydration in an effect — the same SSR-safe pattern
 * the ai-preview / ella-de-preview consumers use — so this never forces the
 * page dynamic and the public NL build is byte-identical (the launcher, already
 * `ssr:false`, simply never mounts without the cookie). Glue imposes no NL gate,
 * so the widget talks to the real KB: this is a live preview of the assistant,
 * not a mock.
 */
export function EllaNlPreviewLauncher(props: ChatLauncherProps) {
  const [active, setActive] = useState(false)
  useEffect(() => {
    setActive(hasEllaNlPreviewActive())
  }, [])

  if (!active) return null
  return <ChatLauncherLazy {...props} />
}
